module.exports = __webpack_public_path__ + "VIPC9.png?0d244a7c57f62195927c954aa3c198a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC9.png
// module id = 72
// module chunks = 0